import type { MaybeRef } from "vue";
import { computed } from "vue";
import type { TodoLockReason } from "@/components/forms/TodoSubmissionRules/types";
import { getTodoLockReason } from "@/components/forms/TodoSubmissionRules/utils";
import { useCurrentTodo } from "@/composables/useCurrentTodo";

export const useTodoSubmissionRules = (todoId: MaybeRef<string>, applicationId: MaybeRef<string | undefined>) => {
  const { todo, isLoading, refetch } = useCurrentTodo(todoId, applicationId);

  const lockReason = computed<TodoLockReason | undefined>(() => getTodoLockReason(todo.value));

  return { lockReason, isLoading, refetch };
};
